import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ImageUploadEffects } from '@image-upload/effects/image-upload.effects';
import { ImageUploadFeature } from '@image-upload/reducers/image-upload.slice';

@NgModule({
  imports: [
    EffectsModule.forFeature([ImageUploadEffects]),
    StoreModule.forFeature(ImageUploadFeature),
  ],
})
export class ImageUploadModule {}
